module.exports = __webpack_public_path__ + "f944c39abefea6af202e2bc228e83a38.svg";